export const skillsEN = {
  title:
    "In summary, i have experience working with these tools and often use them:",
  data: [
    "Python, JS/TS",
    "Django, FastAPI, Pandas",
    "React, Next.js",
    "System Design, Architecture",
    "Docker, Kubernetes",
    "GitHub/GitLab CI/CD",
    "Linux, Nginx, DevOps Basics",
    "AI-Assisted Development, Claude Code",
    "LLM Feature Integration",
  ],
};
